export const filterConstants = {
  active: 'active',
  inactive: 'inactive',
  activeFuture: 'activeFuture'
};
